<template>
  <div class="device-doorbell">
    <div class="page-search-block">
      <!-- <span class="w-90 inline-block align-r m-r-8">高级筛选：</span> -->
      <div class="inline-block">
        <span class="w-90 inline-block align-r m-r-8">门铃编码：</span>
        <el-input v-model="filters.search.deviceCode" class="w-120" placeholder="请输入" ></el-input>
      </div>
      <div class="inline-block">
        <span class="w-90 inline-block align-r m-r-8">房源名称：</span>
        <el-input v-model="filters.search.roomName" class="w-120" placeholder="请输入" ></el-input>
      </div>
      <div class="inline-block">
        <span class="w-90 inline-block align-r m-r-8">在线状态：</span>
        <el-select v-model="filters.search.deviceStatus" filterable placeholder="请选择" clearable>
          <el-option label="在线" :value="1"></el-option>
          <el-option label="离线" :value="2"></el-option>
        </el-select>
      </div>
      <el-button class="submit-btn m-l-10" size="large" type="primary" @click="handleSearch">搜 索</el-button>
    </div>
    
    <div class="page-operate-block">
      <span class="tit">门铃列表</span>
      <div>
        <el-button
          v-if="userInfo.userType === 1"
          class="operate-btn"
          @click="() => paramsConfig.visible = true"
        >参数配置</el-button>
        <el-button
          v-if="userInfo.userType === 1"
          class="operate-btn"
          @click="() => batchUpgrade.visible = true"
        >批量升级</el-button>
        <el-popover placement="bottom" trigger="click" popper-class="r-popover">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <br />
          <el-checkbox v-for="(column, index) in tableColumn" v-model="column.visible" :key="index" @change="_checkChange">{{column.label}}</el-checkbox>
          <template #reference>
            <el-button class="operate-btn">数据项</el-button>
          </template>
        </el-popover>
        <el-button
          v-permission="'bind'"
          class="operate-btn"
          @click="handleEdit"
          :disabled="!(this.options.selection.length == 1 && !this.options.selection[0].roomId)"
          >门铃绑定</el-button>
        <el-button
          v-permission="'unbind'"
          class="operate-btn"
          @click="cancelBind"
          :disabled="!(this.options.selection.length == 1 && this.options.selection[0].roomId)"
          >门铃解绑</el-button>
        <el-button
          v-permission="'export'"
          class="operate-btn"
          @click="handleExportData"
          >导出</el-button>
      </div>
    </div>

    <div class="table-list-block">
      <r-table
        :ref="tableVarity"
        :columns="tableColumn"
        :dataSource="tableData"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
        @row-click="handleRowClick"
        @sort-change="onSortChange"
      ></r-table>
    </div>

    <RModal
      customClass="m-h-unset"
      title="门铃绑定"
      top="15vh"
      :show="detailModal"
      :closeOnClick="false"
      width="500px"
      @change="detailModal = false"
      @close="detailModal = false"
    >
      <template #content>
        <BindView
          :storeId="curStore.id"
          :detailModal="detailModal"
          :detailData="detailData"
          :deviceType="deviceType"
          @submitSuccess="submitSuccess"
          @close="closeModel" />
      </template>
    </RModal>

    <RModal
      title="参数配置"
      :show="paramsConfig.visible"
      @close="paramsConfig.visible = false"
    >
      <template #content>
        <el-form>
          <el-form-item label="配置范围" required>
            <el-select v-model="paramsConfig.type">
              <el-option label="全部设备" :value="1"></el-option>
              <el-option label="区域设备" :value="2"></el-option>
              <el-option label="选定设备" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域" v-if="paramsConfig.type == 2" required>
            <AreaCascader
              v-model="paramsConfig.areaCode"
              :end-level="3"
              checkStrictly
            />
          </el-form-item>
          <div style="display: flex;">
            <el-checkbox v-model="paramsConfig.params.pirSensitivity.checked" style="margin-right: 8px;"></el-checkbox>
            <el-form-item label="RIP检测灵敏度" style="margin-bottom: 0;">
              <el-select v-model="paramsConfig.params.pirSensitivity.value">
                <el-option label="高" :value="1"></el-option>
                <el-option label="中" :value="2"></el-option>
                <el-option label="低" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-checkbox v-model="paramsConfig.params.pirDuration.checked" style="margin-right: 8px;"></el-checkbox>
            <el-form-item label="RIP唤醒休眠时间" style="margin-bottom: 0;">
              <el-input-number
                v-model="paramsConfig.params.pirDuration.value"
                :min="5"
                :max="60"
                :step="1"
                step-strictly
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-checkbox v-model="paramsConfig.params.capInterval.checked" style="margin-right: 8px;"></el-checkbox>
            <el-form-item label="人脸抓拍间隔时间" style="margin-bottom: 0;">
              <el-input-number
                v-model="paramsConfig.params.capInterval.value"
                :min="3"
                :max="10"
                :step="1"
                step-strictly
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-checkbox v-model="paramsConfig.params.faceSize.checked" style="margin-right: 8px;"></el-checkbox>
            <el-form-item label="人脸抓拍小图大小" style="margin-bottom: 0;">
              <el-select v-model="paramsConfig.params.faceSize.value">
                <el-option label="128*128" :value="1"></el-option>
                <el-option label="144*144" :value="2"></el-option>
                <el-option label="160*160" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-checkbox v-model="paramsConfig.params.needBigPic.checked" style="margin-right: 8px;"></el-checkbox>
            <el-form-item label="是否上传背景图" style="margin-bottom: 0;">
              <el-radio v-model="paramsConfig.params.needBigPic.value" :label="true">是</el-radio>
              <el-radio v-model="paramsConfig.params.needBigPic.value" :label="false">否</el-radio>
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-checkbox v-model="paramsConfig.params.heartBeatInterval.checked" style="margin-right: 8px;"></el-checkbox>
            <el-form-item label="心跳间隔时间" style="margin-bottom: 0;">
              <el-input-number
                v-model="paramsConfig.params.heartBeatInterval.value"
                :min="1"
                :max="24"
                :step="1"
                step-strictly
              ></el-input-number>
            </el-form-item>
          </div>
          <div>
            <div style="display: flex;">
              <el-checkbox v-model="paramsConfig.params.server.checked" style="margin-right: 8px;"></el-checkbox>
              <el-form-item label="服务器配置" style="margin-bottom: 0; display: block;"></el-form-item>
            </div>
            <div style="padding-left: 32px;">
              <el-form-item label="服务器IP地址" required style="margin-bottom: 0;">
                <el-input v-model="paramsConfig.params.server.value.ip"/>
              </el-form-item>
              <el-form-item label="服务器端口" required style="margin-bottom: 0;">
                <el-input v-model="paramsConfig.params.server.value.port"/>
              </el-form-item>
              <div style="display: flex;">
                <el-form-item label="账号" required style="margin-bottom: 0; margin-right: 8px;">
                  <el-input v-model="paramsConfig.params.server.value.username"/>
                </el-form-item>
                <el-form-item label="密码" required style="margin-bottom: 0;">
                  <el-input v-model="paramsConfig.params.server.value.password"/>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
        <div style="display: flex; justify-content: center;">
          <el-button type="primary" @click="submitParamsConfig">提交</el-button>
          <el-button @click="paramsConfig.visible = false">取消</el-button>
        </div>
      </template>
    </RModal>
    <RModal
      title="批量升级"
      :show="batchUpgrade.visible"
      @close="batchUpgrade.visible = false"
    >
      <template #content>
        <el-form>
          <el-form-item label="升级范围" required>
            <el-select v-model="batchUpgrade.type">
              <el-option label="全部设备" :value="1"></el-option>
              <el-option label="区域设备" :value="2"></el-option>
              <el-option label="选定设备" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域" v-if="batchUpgrade.type == 2" required>
            <AreaCascader
              v-model="batchUpgrade.areaCode"
              :end-level="3"
              checkStrictly
            />
          </el-form-item>
          <el-form-item label="升级版本" required>
            <el-select v-model="batchUpgrade.params.versionId">
              <el-option :label="e.firmwareName" :value="e.id" v-for="(e, i) of versionList" :key="i"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="升级时间" required>
            每天
            <el-time-picker format="HH:mm" :clearable="false" v-model="batchUpgrade.params.startTime" style="margin: 0 8px; width: 120px;" placeholder="开始时间"></el-time-picker>
            -
            <el-time-picker format="HH:mm" :clearable="false" v-model="batchUpgrade.params.endTime" style="margin: 0 8px; width: 120px;" placeholder="结束时间"></el-time-picker>
          </el-form-item>
        </el-form>
        <div style="display: flex; justify-content: center;">
          <el-button type="primary" @click="submitBatchUpgrade">提交</el-button>
          <el-button @click="batchUpgrade.visible = false">取消</el-button>
        </div>
      </template>
    </RModal>
  </div>
</template>

<script>
import RModal from "@/components/common/RModal"
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import checkMix from "@/components/common/checkAll.js";
import BindView from './bindView'
import AreaCascader from '@/components/common/areaCascader'
import {formatTime} from "@/utils/index.js";
import { mapState } from "vuex"

const EQUIPMENT_TYPE = 104 // 设备类型：门铃

export default {
  name: 'equipDoorbell',
  mixins: [tableMix, checkMix],
  components: { RModal, RTable, BindView, AreaCascader },
  data() {
    return {
      versionList: [],
      batchUpgrade: {
        visible: false,
        type: 2,
        areaCode: [],
        params: {
          endTime: "",
          startTime: "",
          versionId: "",
        },
      },
      paramsConfig: {
        visible: false,
        type: 2,
        areaCode: [],
        params: {
          capInterval: { // 抓拍间隔，多长时间保存一组图片，单位/秒，3 - 10s 可设，默认 5s
            checked: false,
            value: 5,
          },
          faceSize: { // 设置抓拍人脸小图的尺寸大小：1-(128*128)，2-(144*144)，3-(160*160)，默认2-(144*144)
            checked: false,
            value: 2,
          },
          heartBeatInterval: { // 心跳间隔时长设置，单位小时：1 - 4 小时/次可设，默认 4 小时/次
            checked: false,
            value: 4,
          },
          needBigPic: { // 是否需要背景图，默认true
            checked: false,
            value: true,
          },
          pirDuration: { // PIR 唤醒后抓拍时长，单位 s: 5-60S 可设，默认 10S
            checked: false,
            value: 10,
          },
          pirSensitivity: { // PIR 灵敏度：1-高/2-中/3-低，默认2-中
            checked: false,
            value: 2,
          },
          server: {
            checked: false,
            value: {
              ip: "",
              password: "",
              port: "",
              username: "",
            },
          },
        },
      },
      curStore: {},

      deviceType: EQUIPMENT_TYPE,
      // =================================================== 列表 table
      tableVarity: 'equip-doorbell-table',
      tableColumn: [],
      tableData: [],
      detailModal: false,
      detailData: {},
      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        mutiSelect: true,
        selection: [],
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      },
      // 查询参数
      filters: {
        search: {
          deviceCode: '', roomName: '', deviceStatus: ''
        },
      },
      // 0=正常 1=卡不存在 2=卡格式错误 3=卡只读
      tfCardStatusList: ['正常', '卡不存在', '卡格式错误', '卡只读'],
      sortParams: {},
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.common.user
    })
  },
  beforeUnmount() {
    this.$eventBus.off('change-shop')
  },
  created() {
    this.getVersionList();
    let curStore = localStorage.getItem('curShop')
    if (!curStore || curStore === 'undefined' || curStore === 'null') {
      this.curStore = {}
    } else {
      this.curStore = JSON.parse(curStore)
    }
    this.$eventBus.on('change-shop', store => {
      this.curStore = store
      this.getDataList(true)
    })

    this.initTableColumns()
    this.getQuery()
  },
  methods: {
    toLine(string){
      return string.replace(/([A-Z])/g, "_$1").toLowerCase();
    },
    onSortChange({order, prop}){
      const params = {};
      if(prop) params.orderFields = this.toLine(prop);
      if(order){
        params.sort = {
          ascending: 'asc',
          descending: 'desc',
        }[order];
      }
      this.sortParams = params;
      this.getQuery();
    },
    getVersionList(){
      this.axios.get('/api/web/upgradeFirmware/findPage').then(res => {
        this.versionList = res.data.data.data;
      })
    },
    submitParamsConfig(){
      const params = {
        all: this.paramsConfig.type == 1,
        configDTO: Object.entries(
            this.paramsConfig.params
          ).filter(([key, {checked}]) => checked)
          .reduce((acu, [key, {value}]) => {
            acu[key] = value;
            return acu;
          }, {})
      };
      if(this.paramsConfig.type == 2){
        if(!this.paramsConfig.areaCode.length) return this.$message('请选择区域')
        params.areaCode = this.paramsConfig.areaCode;
      }
      if(this.paramsConfig.type == 3) {
        if(!this.options.selection.length) return this.$message.error('您还未选择设备，请选择设备再操作');
        params.deviceCodes = this.options.selection.map(e => e.deviceCode);
      }
      this.fetchData({
        url: 'DEVICE.DOORBELL_CONFIG_ISSUED',
        method: "post",
        headers: {
          'Content-Type': "application/json",
        },
        params,
      }).then(res => {
        console.log(res);
        this.$message.success('配置成功')
      }).catch((err) => {
        console.error(err)
        this.$message.error('配置失败')
      }).finally(() => {
        this.paramsConfig.visible = false
      })
    },
    submitBatchUpgrade(){
      const params = {
        all: this.batchUpgrade.type == 1,
        startTime: formatTime(this.batchUpgrade.params.startTime, 'HH:mm'),
        endTime: formatTime(this.batchUpgrade.params.endTime, 'HH:mm'),
        versionId: this.batchUpgrade.params.versionId,
      }
      if(this.batchUpgrade.type == 2){
        if(!this.batchUpgrade.areaCode.length) return this.$message('请选择区域')
        params.areaCode = this.batchUpgrade.areaCode;
      }
      if(this.batchUpgrade.type == 3) {
        if(!this.options.selection.length) return this.$message.error('您还未选择设备，请选择设备再操作');
        params.deviceCodes = this.options.selection.map(e => e.deviceCode);
      }
      this.fetchData({
        url: 'DEVICE.BATCH_UPGRADE',
        method: "post",
        headers: {
          'Content-Type': "application/json",
        },
        params,
      }).then(res => {
        console.log(res);
        this.$message.success('批量升级成功')
      }).catch((err) => {
        console.error(err)
        this.$message.error('批量升级失败')
      }).finally(() => {
        this.batchUpgrade.visible = false
      })
    },
    // 初始化自定义表头
    initTableColumns() {
      // 表头 visible：默认可见
      let columns = [
        { prop: 'deviceCode', label: '门铃编码', visible: true, minWidth: 200, sortable: 'custom' },
        { prop: 'electricity', label: '电量', visible: true, minWidth: 120 },
        { prop: 'deviceStatus', label: '在线状态', visible: true, minWidth: 120 },
        { prop: 'tfCardStatus', label: 'TF卡状态', visible: true, minWidth: 120 },
        { prop: 'firstCaptureTime', label: '首次抓拍时间', visible: false, minWidth: 160 }, // 
        { prop: 'realManagerName', label: '经营者名称', visible: true, minWidth: 130 },
        { prop: 'roomName', label: '房源名称', visible: true, minWidth: 250 },
        { prop: 'roomCode', label: '房源编码', visible: false, minWidth: 250 },
        { prop: 'roomAddress', label: '房源地址', visible: true, minWidth: 300 }, // 
        { prop: 'roomNum', label: '房间号', visible: false, minWidth: 120 }, // 
        { prop: 'deviceModel', label: '门铃型号', visible: false, minWidth: 190 },
        { prop: 'companyName', label: '门铃厂商', visible: false, minWidth: 250 },
        { prop: 'deviceVersion', label: '版本信息', visible: true, minWidth: 250 },
        { prop: 'latestHeartbeatTime', label: '最近一次心跳时间', visible: true, minWidth: 170, sortable: 'custom' }, // 
        { prop: 'lastCaptureTime', label: '近一次抓拍时间', visible: true, minWidth: 160 }, // 
        { prop: 'installPerson', label: '门铃安装人', visible: false, minWidth: 160 },
        { prop: 'installTime', label: '门铃安装时间', visible: true, minWidth: 160 },
      ]

      columns.forEach((item) => {
        if (item.prop === 'deviceCode') {
          item.render = (row, index, column) => {
            return <a onClick={this.handleShowDetail.bind(this, row)}>{row[item.prop]}</a>
          }
        }
        else if(item.prop === 'electricity'){
          item.render = (row, index, column) => {
            const value = row[item.prop];
            return <span>{typeof value == 'number' ? value : '--'}</span>
          }
        }
        else if (item.prop === 'deviceStatus') {
          item.render = (row, index, column) => {
            return <span>{ row[item.prop] == 1 ? '在线' : '离线' }</span>
          }
        } else if (item.prop === 'tfCardStatus') {
          item.render = (row, index, column) => {
            return <span>{ this.tfCardStatusList[row[item.prop]] }</span>
          }
        } else if (item.prop === 'companyName') {
          item.render = (row, index, column) => {
            return <span>瑞为技术</span>
          }
        } else {
          item.render = (row, index, column) => {
            return <span>{(row[item.prop] == '' || row[item.prop] == null) ? '--' : row[item.prop]}</span>
          }
        }
      })

      this.tableColumn = columns
    },
    // 显示日志详情
    handleShowDetail(row) {
      this.$emit('change-view', row)
    },
    // 获取查询参数
    getQueryParams() {
      let searches = { deviceType: this.deviceType }
      for (let name in this.filters.search) {
        if (this.filters.search[name] === '') {
          continue
        }
        let searchParam = this.filters.search[name]
        searches[name] = typeof searchParam === 'string' ? searchParam.trim() : searchParam
      }

      return {
        ...searches,
        storeId: this.curStore.id || '',
        pageNumber: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
        ...this.sortParams,
      }
    },
    // 查询列表数据
    getQuery() {
      this.options.loading = true
      let params = this.getQueryParams()

      let url = 'DEVICE.GET_LIST'
      this.fetchData({ url, method: 'get', params })
        .then((res) => {
          this.options.loading = false

          if (!res || !res.data) {
            this.tableData = []
            this.pagination.total = 0
          } else {
            this.tableData = res.data || []
            this.pagination.total = res.rowCount
          }
        }).catch((err) => {
          console.log(err, '==== 门铃获取失败')
        }).finally(() => {
          this.options.loading = false
        })
    },
    // 打开绑定弹框
    handleEdit() {
      this.$nextTick(() => {
        this.detailModal = true
        if (this.options.selection.length) {
          this.detailData = { ...this.options.selection[0] }
        } else {
          this.detailData = {}
        }
      })
    },
    // 提示解绑
    cancelBind() {
      let tipStr = "该操作是不可恢复的，确定解绑？";
      this.$confirm(tipStr, { type: "warning" })
        .then(() => {
          this.doCancelBind();
        })
        .catch(() => false);
    },
    // 确认解绑
    doCancelBind() {
      let url = "DEVICE.GET_UNBIND";
      let delDevice = this.options.selection[0]
      let params = {
        roomId: delDevice.roomId,
        deviceCode: delDevice.deviceCode,
        deviceType: this.deviceType,
      };
      this.fetchData({ url, method: "get", params, flag: true }).then((res) => {
        if (res.code == 200) {
          this.$message.success('解绑成功！')
          this.submitSuccess()
          return
        }
        this.$message.error(res.msg || '解绑失败！')
      }).catch((err) => {
        this.$message.error(err || "解绑失败！")
      }).finally(() => {
        this.saveLoading = false;
      });
    },
    // 操作成功，刷新列表
    submitSuccess() {
      this.detailModal=false
      this.getDataList()
    },
    // 关闭弹框
    closeModel() {
      this.detailModal=false
    },
    // 导出数据
    handleExportData() {
      let list = this.options.selection
      if (!list.length) {
        let tipStr = '是否导出全部门铃数据？'
        this.$confirm(tipStr, { type: 'warning' }).then(() => {
          this.exportExcel()
        }).catch(() => false)
        return
      }

      let ids = list.map(item => item.id)
      this.exportExcel(ids)
    },
    // 导出excel
    exportExcel(ids) {
      let url = 'DEVICE.GET_EXPORT'
      let params = {
        pageNumber: 1,
        pageSize: 99999999
      }

      if (ids) {
        params.ids = ids
      }

      this.fetchData({ url, method: "get", params, flag: true }).then((res) => {
        let blob = blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
        let aEl = document.createElement('a')
        let href = window.URL.createObjectURL(blob)
        aEl.download = '全部门铃.xlsx'
        aEl.href = href

        document.body.appendChild(aEl)
        aEl.click()

        document.body.removeChild(aEl)
        window.URL.revokeObjectURL(href)
      })
    },
  },
}
</script>

<style lang="less">
.m-h-unset .el-dialog__body {
  min-height: unset !important;
}
</style>